export const CREDITO_TRIBUTARIO = [
  {
    "exercicio": "1999",
    "ct": "009422339",
    "dataVencimentoNotificacao": "20140430",
    "valorOriginal": 920.83,
    "saldoDevedor": 920.83,
    "codigoSituacao": "60",
    "situacao": "Enviado A PFN",
    "tipoNotificacao": {
      "codigo": "02",
      "descricao": "Imp Suplem (A)"
    },
    "numeroDeclaracao": "0830063997",
    "unidadeMonetaria": "REAL",
    "numeroLancamento": "",
    "numeroProcesso": "12345678901234567",
    "periodoApuracao": "19981231",
    "componentes": [
      {
        "numero": "01",
        "receita": "2904",
        "dataVencimento": "19990430",
        "dataProrrogacao": "",
        "valorOriginal": 526.19,
        "saldoDevedor": 526.19,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "I"
      },
      {
        "numero": "02",
        "receita": "3018",
        "dataVencimento": "20001106",
        "dataProrrogacao": "",
        "valorOriginal": 394.64,
        "saldoDevedor": 394.64,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "M"
      }
    ],
    "pagamentos": []
  },
  {
    "exercicio": "2003",
    "ct": "026402880",
    "dataVencimentoNotificacao": "20031027",
    "valorOriginal": 909.66,
    "saldoDevedor": 909.66,
    "codigoSituacao": "60",
    "situacao": "Enviado A PFN",
    "tipoNotificacao": {
      "codigo": "08",
      "descricao": "Lanc Normal Extrato"
    },
    "numeroDeclaracao": "0813781280",
    "unidadeMonetaria": "REAL",
    "numeroLancamento": "",
    "numeroProcesso": "00000000000000000",
    "periodoApuracao": "20021231",
    "componentes": [
      {
        "numero": "01",
        "receita": "0211",
        "dataVencimento": "20030430",
        "dataProrrogacao": "",
        "valorOriginal": 151.61,
        "saldoDevedor": 151.61,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "I"
      },
      {
        "numero": "02",
        "receita": "0211",
        "dataVencimento": "20030530",
        "dataProrrogacao": "",
        "valorOriginal": 151.61,
        "saldoDevedor": 151.61,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "I"
      },
      {
        "numero": "03",
        "receita": "0211",
        "dataVencimento": "20030630",
        "dataProrrogacao": "",
        "valorOriginal": 151.61,
        "saldoDevedor": 151.61,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "I"
      },
      {
        "numero": "04",
        "receita": "0211",
        "dataVencimento": "20030731",
        "dataProrrogacao": "",
        "valorOriginal": 151.61,
        "saldoDevedor": 151.61,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "I"
      },
      {
        "numero": "05",
        "receita": "0211",
        "dataVencimento": "20030829",
        "dataProrrogacao": "",
        "valorOriginal": 151.61,
        "saldoDevedor": 151.61,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "I"
      },
      {
        "numero": "06",
        "receita": "0211",
        "dataVencimento": "20030930",
        "dataProrrogacao": "",
        "valorOriginal": 151.61,
        "saldoDevedor": 151.61,
        "situacao": "Enviado A PFN",
        "indicadorEncargo": "I"
      }
    ],
    "pagamentos": []
  },
  {
    "exercicio": "2016",
    "ct": "036565350",
    "dataVencimentoNotificacao": "20160726",
    "valorOriginal": 2196.66,
    "saldoDevedor": 2196.66,
    "codigoSituacao": "14",
    "situacao": "Devedor",
    "tipoNotificacao": {
      "codigo": "08",
      "descricao": "Lanc Normal Extrato"
    },
    "numeroDeclaracao": "0819677534",
    "unidadeMonetaria": "REAL",
    "numeroLancamento": "",
    "numeroProcesso": "00000000000000000",
    "periodoApuracao": "20151231",
    "componentes": [
      {
        "numero": "01",
        "receita": "0211",
        "dataVencimento": "20150429",
        "dataProrrogacao": "",
        "valorOriginal": 366.11,
        "saldoDevedor": 366.11,
        "situacao": "Devedor",
        "indicadorEncargo": "I"
      },
      {
        "numero": "02",
        "receita": "0211",
        "dataVencimento": "20150531",
        "dataProrrogacao": "",
        "valorOriginal": 366.11,
        "saldoDevedor": 366.11,
        "situacao": "Devedor",
        "indicadorEncargo": "I"
      },
      {
        "numero": "03",
        "receita": "0211",
        "dataVencimento": "20160630",
        "dataProrrogacao": "",
        "valorOriginal": 366.11,
        "saldoDevedor": 366.11,
        "situacao": "Devedor",
        "indicadorEncargo": "I"
      },
      {
        "numero": "04",
        "receita": "0211",
        "dataVencimento": "20160729",
        "dataProrrogacao": "",
        "valorOriginal": 366.11,
        "saldoDevedor": 366.11,
        "situacao": "Devedor",
        "indicadorEncargo": "I"
      },
      {
        "numero": "05",
        "receita": "0211",
        "dataVencimento": "20160831",
        "dataProrrogacao": "",
        "valorOriginal": 366.11,
        "saldoDevedor": 366.11,
        "situacao": "Devedor",
        "indicadorEncargo": "I"
      },
      {
        "numero": "06",
        "receita": "0211",
        "dataVencimento": "20160930",
        "dataProrrogacao": "",
        "valorOriginal": 366.11,
        "saldoDevedor": 366.11,
        "situacao": "Devedor",
        "indicadorEncargo": "I"
      }
    ],
    "pagamentos": []
  }
];
